(() => {
  'use strict';
  if (customElements.get('vukar-product-finder')) return;
  const rulesRequests = new Map();
  const featureKeys = ['level', 'cyclic', 'clock', 'daily_runtime', 'auto_off', 'auto_restart'];
  const icons = {
    panel: ['M7 3h18v26H7z', 'M11 7h10v7H11z', 'M12 21h.01', 'M20 21h.01'],
    device: ['M9 6h14v20H9z', 'M13 10h6v5h-6z', 'M13 21h6', 'M12 2v4M20 2v4M12 26v4M20 26v4'],
    meter: ['M4 7h24v18H4z', 'M8 11h16v9H8z', 'M11 14h3v3h-3M18 14h3v3h-3'],
    single: ['M16 4v24', 'M11 9l5-5 5 5', 'M11 23l5 5 5-5'],
    three: ['M7 5v22M16 5v22M25 5v22', 'M4 9l3-4 3 4M13 9l3-4 3 4M22 9l3-4 3 4'],
    borewell: ['M12 9h8v20h-8z', 'M14 2h4v7M16 2h11v6', 'M2 29h28M14 14h4M14 19h4M14 24h4'],
    openwell: ['M5 6v23h22V6', 'M6 19c4-4 6 4 10 0s6 4 10 0', 'M13 8h6v17h-6zM16 8V2'],
    monoblock: ['M12 12h14v13H12z', 'M6 15h6v9H6zM3 11h4v13M26 15h3v6h-3', 'M10 28h18M16 16v5M21 16v5'],
    manual: ['M11 17V7a2 2 0 0 1 4 0v8-3a2 2 0 0 1 4 0v3-1a2 2 0 0 1 4 0v2a2 2 0 0 1 4 0v6c0 5-4 7-8 7-4 0-6-2-8-5l-5-7a2 2 0 0 1 3-3l2 3'],
    auto: ['M25 11a11 11 0 1 0 1 9', 'M25 3v8h-8', 'M16 10v7l4 2'],
    level: ['M5 6v22h22V6', 'M6 16c4-4 6 4 10 0s6 4 10 0', 'M11 7l4 4 7-7'],
    cyclic: ['M26 11a11 11 0 0 0-19-3L4 11', 'M4 4v7h7', 'M6 21a11 11 0 0 0 19 3l3-3', 'M28 28v-7h-7'],
    clock: ['M16 29a13 13 0 1 0 0-26 13 13 0 0 0 0 26', 'M16 8v9l6 3'],
    daily_runtime: ['M6 6h20v23H6z', 'M6 12h20M11 2v7M21 2v7', 'M12 19l3 3 6-6'],
    auto_off: ['M16 3v12', 'M9 7a12 12 0 1 0 14 0'],
    unknown: ['M16 29a13 13 0 1 0 0-26 13 13 0 0 0 0 26', 'M12 11a4 4 0 0 1 8 0c0 3-4 3-4 6M16 23h.01']
  };
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined) element.textContent = String(value);
    return element;
  };
  const icon = (key) => {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    const add = (tag, attrs, value) => {
      const element = document.createElementNS(ns, tag);
      Object.entries(attrs).forEach(([name, item]) => element.setAttribute(name, String(item)));
      if (value !== undefined) element.textContent = value;
      svg.append(element);
      return element;
    };
    svg.setAttribute('viewBox', '0 0 96 72');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.classList.add('vpf__icon', 'vpf__icon--illustrated');
    const text = (x, y, value, size = 12, color = 'currentColor') => add('text', { x, y, fill: color, stroke: 'none', 'text-anchor': 'middle', 'font-family': 'system-ui, sans-serif', 'font-size': size, 'font-weight': '700' }, value);
    const path = (d, color = 'currentColor') => add('path', { d, stroke: color });
    const box = (x, y, width, height, fill = '#f1f2eb') => add('rect', { x, y, width, height, rx: 5, fill });
    const dot = (x, y, fill) => add('circle', { cx: x, cy: y, r: 11, fill, stroke: 'none' });
    if (key === 'single' || key === 'three') {
      const terminals = key === 'single' ? [['P', 32, '#a54132'], ['N', 64, '#315f84']] : [['R', 20, '#a54132'], ['Y', 48, '#8a6700'], ['B', 76, '#315f84']];
      terminals.forEach(([label, x, color]) => { dot(x, 21, color); text(x, 25, label, 12, '#ffffff'); path(`M${x} 34v9`, color); });
      text(48, 65, key === 'single' ? '230V' : '440V', 17);
    } else if (key === 'borewell') {
      path('M10 12h76M21 12v50M75 12v50', '#9ba99c');
      box(38, 26, 20, 37, '#e4edf0'); path('M48 26V7h24v12M43 35h10M43 43h10M43 51h10');
      path('M9 48q8-5 16 0t16 0M58 48q8-5 16 0t13 0', '#46778d');
    } else if (key === 'openwell') {
      path('M12 13v49h72V13M22 24v29h52V24', '#9ba99c');
      path('M22 37q9-6 18 0t18 0t16 0', '#46778d'); box(40, 39, 17, 21, '#e4edf0');path('M48 39V8h27v9');
    } else if (key === 'monoblock') {
      path('M8 61h80M12 27v23h16M12 27H4', '#9ba99c'); box(26, 25, 21, 30, '#e4edf0');box(47, 19, 33, 36);path('M55 26v22M63 26v22M71 26v22M33 25V9h17M30 58v3M75 58v3');
    } else if (key === 'level') {
      path('M13 11v49h70V11');path('M14 36q9-6 17 0t17 0t17 0t17 0','#46778d');path('M68 9v29M61 39h14');text(38,25,'FULL',10);path('M32 48l6 6 12-12','#55765d');
    } else if (key === 'cyclic') {
      path('M18 16h57l-7-7M78 55H21l7 7M78 17v12M18 55V43');box(9,26,33,23,'#e9f0e3');box(54,26,33,23);text(25,42,'ON',12);text(71,42,'OFF',11);
    } else if (key === 'clock') {
      add('circle',{cx:48,cy:31,r:25,fill:'#f1f2eb'});path('M48 12v4M67 31h4M48 46v4M25 31h4M48 21v11l12 6');text(48,69,'CLOCK',10);
    } else if (key === 'daily_runtime') {
      box(16,11,64,51);path('M16 26h64M30 6v11M66 6v11');text(48,49,'24h',20);path('M27 56h42');
    } else if (key === 'auto_off') {
      add('circle',{cx:43,cy:35,r:24,fill:'#f1f2eb'});path('M43 11V5M35 5h16M43 21v14l9 5');box(60,41,27,23,'#f1e5de');text(74,57,'OFF',10);
    } else if (key === 'auto_restart' || key === 'auto') {
      path('M77 20a29 29 0 1 0 1 32M77 7v15H62');path('M48 16v19M34 26a19 19 0 1 0 28 0');
    } else if (key === 'manual') {
      box(16,17,64,38);box(22,23,25,26,'#e3eddf');box(49,23,25,26);text(35,40,'ON',11);text(62,40,'OFF',10);path('M35 54v11M30 61l5-7 5 7');
    } else {
      const group = add('g', { transform: 'translate(24 9) scale(1.5)' });
      (icons[key] || icons.unknown).forEach((d) => { const shape = document.createElementNS(ns, 'path');shape.setAttribute('d', d);group.append(shape); });
    }
    return svg;
  };
  const number = (value) => typeof value === 'number' && Number.isFinite(value);
  const inRange = (value, min, max) => number(value) && number(min) && number(max) && value >= min && value <= max;
  const withinKnownBounds = (value, min, max) => number(value) && value > 0 && (number(min) || number(max)) && (!number(min) || value >= min) && (!number(max) || value <= max);
  const cleanModel = (model) => String(model || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  class VukarProductFinder extends HTMLElement {
    static horsepower(value, plain = false) {
      const text = String(value || '').toLowerCase().replace(/h\.\s*p\.?/g, 'hp').replace(/(\d+)\s*½/g, (_, whole) => String(Number(whole) + 0.5)).replace(/(\d+)\s*¾/g, (_, whole) => String(Number(whole) + 0.75)).replace(/(\d+)\s*¼/g, (_, whole) => String(Number(whole) + 0.25)).replace(/½/g, '0.5').replace(/¾/g, '0.75').replace(/¼/g, '0.25');
      if ((text.match(/hp\b/g) || []).length > 1) return null;
      const explicit = /\bhp\b/.test(text) || /\d\s*hp\b/.test(text);
      if (!explicit && !plain) return null;
      const upper = text.match(/\b(?:up\s*to|upto)\s*(\d+(?:\.\d+)?)\s*hp\b/);
      if (upper && Number(upper[1]) > 0) return { min: null, max: Number(upper[1]), kind: 'up_to' };
      const normalized = text.replace(/horse\s*power|horsepower|hp/g, '').trim();
      const fraction = normalized.match(/^\s*(\d+)\s*\/\s*(\d+)\s*$/);
      if (fraction && Number(fraction[2]) > 0) return { min: Number(fraction[1]) / Number(fraction[2]), max: Number(fraction[1]) / Number(fraction[2]) };
      const range = normalized.match(/^\s*(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)\s*$/);
      if (range) return { min: Number(range[1]), max: Number(range[2]) };
      const exact = normalized.match(/^\s*(\d+(?:\.\d+)?)\s*$/);
      if (exact) return { min: Number(exact[1]), max: Number(exact[1]) };
      const title = text.match(/(?:^|\s|[(/])(\d+(?:\.\d+)?)\s*hp\b/g);
      if (title && title.length === 1 && !/\d\s*(?:[-–—/]|to)\s*\d/.test(text)) {
        const hp = Number(title[0].match(/\d+(?:\.\d+)?/)[0]);
        return { min: hp, max: hp };
      }
      return null;
    }
    static variantHP(variant) {
      for (const option of variant.selected_options || []) {
        const named = /\bhp\b|horse\s*power|horsepower/i.test(option.name || '');
        const hp = this.horsepower(option.value, named);
        if (hp) return hp;
      }
      return this.horsepower(variant.title);
    }
    static eligibleVariant(product, rule, answer) {
      const variants = Array.isArray(product.variants) ? product.variants : [];
      if (answer.goal !== 'panel') return variants.length === 1 && variants[0].available === true && String(variants[0].id) !== '51610982351154' ? variants[0] : null;
      const parsed = variants.map((variant) => ({ variant, hp: this.variantHP(variant) }));
      const hasHP = parsed.some((entry) => entry.hp);
      return parsed.filter(({ variant, hp }) => {
        if (variant.available !== true || String(variant.id) === '51610982351154') return false;
        if (cleanModel(rule.model) === 'BOAH' && hp && hp.max > 2) return false;
        if (hp) return hp.kind === 'up_to' ? number(answer.hp) && answer.hp > 0 && answer.hp <= hp.max : inRange(answer.hp, hp.min, hp.max);
        return !hasHP && variants.length === 1 && /^default title$/i.test(variant.title || '');
      }).sort((a, b) => (a.hp ? a.hp.max : Number.POSITIVE_INFINITY) - (b.hp ? b.hp.max : Number.POSITIVE_INFINITY) || Number(a.variant.price) - Number(b.variant.price)).map((entry) => entry.variant)[0] || null;
    }
    static selectCandidates(rules, catalog, answer) {
      if (!['single', 'three'].includes(answer.phase)) return [];
      if (answer.goal === 'panel' && (!['borewell', 'openwell', 'monoblock'].includes(answer.pump) || !number(answer.hp) || answer.hp <= 0)) return [];
      const products = new Map(catalog.map((product) => [product.handle, product]));
      const requirements = [...(answer.features || [])];
      return rules.map((rule, index) => {
        const product = products.get(rule.handle);
        if (rule.ready !== true || !product || product.available !== true || rule.category !== answer.goal || rule.phase !== answer.phase) return null;
        if (rule.source_body_sha256 && product.body_sha256 !== rule.source_body_sha256) return null;
        if (cleanModel(rule.model) === 'BOAH3HP') return null;
        if (answer.goal === 'panel') {
          if (!(rule.pump_types || []).includes(answer.pump) || !withinKnownBounds(answer.hp, rule.hp_min, rule.hp_max)) return null;
          if (cleanModel(rule.model) === 'BOAH' && answer.hp > 2) return null;
        }
        if (answer.goal === 'device' && (rule.pump_types || []).length && !(rule.pump_types || []).includes(answer.pump)) return null;
        if (number(answer.current)) {
          if (number(rule.current_min) && answer.current < rule.current_min) return null;
          if (number(rule.current_max) && answer.current > rule.current_max) return null;
        }
        if (!requirements.every((key) => rule.features && rule.features[key] === true)) return null;
        const variant = this.eligibleVariant(product, rule, answer);
        if (answer.goal === 'panel' && !variant) return null;
        if (answer.goal === 'panel' && (!number(rule.hp_min) || !number(rule.hp_max)) && !this.variantHP(variant)) return null;
        if (!product.variants.some((candidate) => candidate.available === true && String(candidate.id) !== '51610982351154')) return null;
        const score = 1 + (answer.goal === 'panel' ? 2 : 0) + requirements.length;
        const extras = featureKeys.filter((key) => !requirements.includes(key) && rule.features && rule.features[key] === true).length;
        const price = variant && number(variant.price) ? variant.price : Number.POSITIVE_INFINITY;
        return { product, rule, variant, score, extras, price, index };
      }).filter(Boolean).sort((a, b) => b.score - a.score || a.extras - b.extras || a.price - b.price || a.index - b.index);
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.workspace = this.querySelector('[data-vpf-workspace]');
      this.status = this.querySelector('[data-vpf-status]');
      try {
        this.config = JSON.parse(this.querySelector('[data-vpf-config]').textContent);
        this.labels = JSON.parse(this.config.labels_json);
        this.featureCopy = JSON.parse(this.config.feature_copy_json || '{"features":[],"section":{}}');
        this.catalog = JSON.parse(this.querySelector('[data-vpf-catalog]').textContent).products;
      } catch (_) {
        return;
      }
      this.answer = { goal: null, phase: null, pump: null, hp: null, current: null, operation: null, features: [] };
      this.stepIndex = 0;
      this.resultVersion = 0;
      this.resultLimit = 3;
      this.addEventListener('change', (event) => this.handleChange(event));
      this.addEventListener('input', (event) => this.handleInput(event));
      this.addEventListener('click', (event) => this.handleClick(event));
      this.renderStep(false);
    }
    t(key) { return this.labels[key] || ''; }
    steps() {
      if (this.answer.goal === 'meter') return ['goal', 'phase', 'features'];
      return this.answer.goal === 'device' ? ['goal', 'phase', 'pump', 'features'] : ['goal', 'phase', 'pump', 'motor', 'features'];
    }
    goalPhoto(key) {
      const handle = (this.config.goal_handles || {})[key];
      const product = this.catalog.find((item) => item.handle === handle);
      if (!product || !product.image) return null;
      const media = node('span', 'vpf__choice-media');
      const image = node('img', 'vpf__choice-image');
      image.src = product.image;
      image.alt = product.title;
      image.width = 300;
      image.height = 300;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', () => { image.remove(); media.prepend(icon(key)); }, { once: true });
      media.append(image);
      return media;
    }
    contextPanel() {
      const context = node('aside', 'vpf__context');
      context.setAttribute('aria-label', this.t('selected_summary'));
      const media = this.goalPhoto(this.answer.goal);
      if (media) {
        const visual = node('div', 'vpf__context-visual');
        visual.append(media);
        context.append(visual);
      }
      context.append(node('h4', 'vpf__context-title', this.t('selected_summary')), this.summary());
      return context;
    }
    loadRules() {
      const url = this.dataset.rulesUrl;
      if (!rulesRequests.has(url)) {
        const request = fetch(url, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error('Rules unavailable');
          return response.json();
        }).then((payload) => {
          if (!Array.isArray(payload.products)) throw new Error('Invalid rules');
          return payload.products;
        });
        rulesRequests.set(url, request);
      }
      return rulesRequests.get(url);
    }
    interact() { this.loadRules().catch(() => {}); }
    resetFollowing(key) {
      const sequence = ['goal', 'phase', 'pump', 'motor', 'operation', 'features'];
      const index = sequence.indexOf(key);
      sequence.slice(index + 1).forEach((next) => {
        if (next === 'motor') { this.answer.hp = null; this.answer.current = null; }
        else this.answer[next] = next === 'features' ? [] : null;
      });
    }
    handleChange(event) {
      const target = event.target;
      if (!target.matches('input[data-vpf-key]')) return;
      this.interact();
      const key = target.dataset.vpfKey;
      if (key === 'features') {
        this.answer.features = Array.from(this.querySelectorAll('input[data-vpf-key="features"]:checked')).map((input) => input.value);
      } else if (key === 'hp') {
        this.answer.hp = target.value === 'unsure' ? 'unsure' : Number(target.value);
        const custom = this.querySelector('[data-vpf-custom-hp]');
        if (custom) custom.value = '';
      } else if (this.answer[key] !== target.value) {
        this.resetFollowing(key);
        this.answer[key] = target.value;
      }
      this.clearError();
    }
    handleInput(event) {
      const target = event.target;
      if (target.matches('[data-vpf-custom-hp]')) {
        this.interact();
        this.querySelectorAll('input[data-vpf-key="hp"]').forEach((input) => { input.checked = false; });
        this.answer.hp = target.value.trim() ? Number(target.value) : null;
      } else if (target.matches('[data-vpf-current]')) {
        this.interact();
        this.answer.current = target.value.trim() ? Number(target.value) : null;
      }
      this.clearError();
    }
    handleClick(event) {
      const button = event.target.closest('button[data-vpf-action]');
      if (!button || !this.contains(button)) return;
      const action = button.dataset.vpfAction;
      if (action === 'next') this.next();
      if (action === 'back') {
        this.resultVersion += 1;
        if (!this.isResults) this.stepIndex = Math.max(0, this.stepIndex - 1);
        this.isResults = false;
        this.renderStep();
      }
      if (action === 'edit') {
        this.resultVersion += 1;
        this.stepIndex = Number(button.dataset.vpfStep);
        this.isResults = false;
        this.renderStep();
      }
      if (action === 'restart') {
        this.resultVersion += 1;
        this.answer = { goal: null, phase: null, pump: null, hp: null, current: null, operation: null, features: [] };
        this.stepIndex = 0;
        this.isResults = false;
        this.renderStep();
      }
      if (action === 'more') {
        const firstNewIndex = this.resultLimit;
        this.resultLimit += 3;
        this.renderResultsList();
        const cards = this.querySelectorAll('.vpf__product');
        const firstNew = cards[firstNewIndex];
        if (firstNew) firstNew.querySelector('a').focus();
        this.announce(`${Math.min(this.resultLimit, this.matches.length)} ${this.t('of')} ${this.matches.length} ${this.t('results_count')}`);
      }
    }
    next() {
      this.interact();
      const key = this.steps()[this.stepIndex];
      if (key === 'motor') {
        if (this.answer.hp !== 'unsure' && (!number(this.answer.hp) || this.answer.hp <= 0)) return this.error(this.t('invalid_hp'));
        if (this.answer.current !== null && (!number(this.answer.current) || this.answer.current <= 0 || this.answer.current > 10000)) return this.error(this.t('invalid_current'));
      } else if (key !== 'features' && !this.answer[key]) return this.error(this.t('choose_option'));
      const unknown = this.answer.phase === 'unsure' || (this.answer.goal === 'panel' && (this.answer.pump === 'unsure' || this.answer.hp === 'unsure')); 
      if (unknown || this.stepIndex === this.steps().length - 1) this.showResults(unknown);
      else { this.stepIndex += 1; this.renderStep(); }
    }
    button(label, action, className = 'vpf__button') {
      const button = node('button', className, label);
      button.type = 'button';
      button.dataset.vpfAction = action;
      return button;
    }
    link(label, href, className = 'vpf__button') {
      const link = node('a', className, label);
      link.href = href;
      return link;
    }
    announce(message) { this.status.textContent = message; }
    error(message) {
      this.errorNode.textContent = message;
      this.errorNode.hidden = false;
      this.announce(message);
      const first = this.workspace.querySelector('input');
      if (first) first.focus({ preventScroll: true });
    }
    clearError() { if (this.errorNode) { this.errorNode.hidden = true; this.errorNode.textContent = ''; } }
    topBar(results = false) {
      const top = node('div', 'vpf__top');
      const progress = node('div', 'vpf__progress');
      const index = results ? this.steps().length : this.stepIndex + 1;
      const count = this.steps().length;
      const progressText = node('span', 'vpf__progress-text', results ? this.t('results_title') : `${this.t('step')} ${index} ${this.t('of')} ${count}`);
      const track = node('div', 'vpf__progress-track');
      track.setAttribute('role', 'progressbar');
      track.setAttribute('aria-label', this.t('progress_label'));
      track.setAttribute('aria-valuemin', '0');
      track.setAttribute('aria-valuemax', String(count));
      track.setAttribute('aria-valuenow', String(results ? count : this.stepIndex));
      const fill = node('span', 'vpf__progress-fill');
      fill.style.width = `${(results ? 1 : this.stepIndex / count) * 100}%`;
      track.append(fill);
      progress.append(progressText, track);
      top.append(progress);
      if (this.stepIndex > 0 || results) top.append(this.button(this.t('restart'), 'restart', 'vpf__text-button'));
      return top;
    }
    summary() {
      const summary = node('div', 'vpf__summary');
      summary.setAttribute('aria-label', this.t('selected_summary'));
      this.steps().forEach((key, index) => {
        if (!this.isResults && index >= this.stepIndex) return;
        let value = null;
        if (key === 'goal' && this.answer.goal) value = this.t(`choice_${this.answer.goal}`);
        if (key === 'phase' && this.answer.phase) value = this.t(this.answer.phase === 'unsure' ? 'unknown_option' : `choice_${this.answer.phase}`);
        if (key === 'pump' && this.answer.pump) value = this.t(this.answer.pump === 'unsure' ? 'unknown_option' : `choice_${this.answer.pump}`);
        if (key === 'motor' && this.answer.hp) value = this.answer.hp === 'unsure' ? this.t('motor_unsure') : `${this.answer.hp} ${this.t('hp_unit')}${number(this.answer.current) ? ` · ${this.answer.current} ${this.t('current_unit')}` : ''}`;
        if (key === 'operation' && this.answer.operation) value = this.t(this.answer.operation === 'manual' ? 'choice_manual' : 'choice_auto');
        if (key === 'features' && this.answer.features.length) value = this.answer.features.map((feature) => this.t(`feature_${feature}`)).join(' · ');
        if (!value) return;
        const chip = this.button(`${value} · ${this.t('edit')}`, 'edit', 'vpf__chip');
        chip.dataset.vpfStep = String(index);
        chip.setAttribute('aria-label', `${this.t('edit')}: ${value}`);
        summary.append(chip);
      });
      return summary;
    }
    options(key) {
      if (key === 'goal') return ['panel', 'device', 'meter'].map((value) => ({ value, label: this.t(`choice_${value}`), detail: this.t(`choice_${value}_detail`), icon: value }));
      if (key === 'phase') return ['single', 'three', 'unsure'].map((value) => ({ value, label: this.t(value === 'unsure' ? 'unknown_option' : `choice_${value}`), detail: this.t(value === 'unsure' ? 'unknown_detail' : `choice_${value}_detail`), icon: value === 'unsure' ? 'unknown' : value }));
      if (key === 'pump') return ['borewell', 'openwell', 'monoblock', 'unsure'].map((value) => ({ value, label: this.t(value === 'unsure' ? 'unknown_option' : `choice_${value}`), detail: this.t(value === 'unsure' ? 'unknown_detail' : `choice_${value}_detail`), icon: value === 'unsure' ? 'unknown' : value }));
      if (key === 'operation') return ['manual', 'auto'].map((value) => ({ value, label: this.t(`choice_${value}`), detail: this.t(`choice_${value}_detail`), icon: value }));
      if (key === 'features') return featureKeys.map((value) => {
        const content = this.featureCopy.features.find((feature) => feature.id === value);
        return content ? { value, label: content.label, detail: content.explanation, example: content.example, distinction: content.distinction, icon: value } : { value, label: this.t(`feature_${value}`), detail: this.t(`feature_${value}_detail`), icon: value };
      });
      const ratings = this.answer.phase === 'single' ? [0.5, 0.75, 1, 1.5, 2, 3] : [1, 2, 3, 5, 7.5, 10];
      return ratings.map((value) => ({ value: String(value), label: `${value} ${this.t('hp_unit')}` })).concat([{ value: 'unsure', label: this.t('motor_unsure') }]);
    }
    optionCard(key, choice) {
      const label = node('label', `vpf__option${key === 'motor' ? ' vpf__option--hp' : ''}${key === 'features' ? ' vpf__option--feature' : ''}${key === 'goal' ? ' vpf__option--goal' : ''}`);
      const input = node('input', 'vpf__option-input');
      const field = key === 'motor' ? 'hp' : key;
      input.type = key === 'features' ? 'checkbox' : 'radio';
      input.name = `vpf-${this.dataset.sectionId}-${field}`;
      input.dataset.vpfKey = field;
      input.value = choice.value;
      input.checked = key === 'features' ? this.answer.features.includes(choice.value) : String(this.answer[field]) === choice.value;
      const content = node('span', 'vpf__option-content');
      const photo = key === 'goal' ? this.goalPhoto(choice.value) : null;
      if (photo) content.append(photo);
      else if (choice.icon) content.append(icon(choice.icon));
      const copy = node('span', 'vpf__option-copy');
      copy.append(node('span', 'vpf__option-title', choice.label));
      if (choice.detail) copy.append(node('span', 'vpf__option-detail', choice.detail));
      if (choice.example) {
        const example = node('span', 'vpf__feature-example');
        example.append(node('strong', '', this.featureCopy.section.example_label), node('span', '', choice.example));
        copy.append(example);
      }
      if (choice.distinction) {
        const distinction = node('span', 'vpf__feature-distinction');
        distinction.append(node('strong', '', this.featureCopy.section.distinction_label), node('span', '', choice.distinction));
        copy.append(distinction);
      }
      const mark = node('span', 'vpf__option-mark');
      mark.setAttribute('aria-hidden', 'true');
      content.append(copy, mark);
      label.append(input, content);
      return label;
    }
    motorFields(stage) {
      const fields = node('div', 'vpf__fields');
      const customWrap = node('div', 'vpf__field');
      const custom = node('input', 'vpf__number');
      custom.id = `vpf-${this.dataset.sectionId}-hp`;
      custom.type = 'number'; custom.min = '0.1'; custom.step = 'any'; custom.inputMode = 'decimal';
      custom.dataset.vpfCustomHp = '';
      custom.placeholder = this.t('hp_placeholder');
      if (number(this.answer.hp) && !this.options('motor').some((choice) => Number(choice.value) === this.answer.hp)) custom.value = String(this.answer.hp);
      const customLabel = node('label', 'vpf__field-label', this.t('hp_custom'));
      customLabel.htmlFor = custom.id;
      customWrap.append(customLabel, custom);
      const currentWrap = node('div', 'vpf__field');
      const current = node('input', 'vpf__number');
      current.id = `vpf-${this.dataset.sectionId}-current`;
      current.type = 'number'; current.min = '0.1'; current.max = '10000'; current.step = 'any'; current.inputMode = 'decimal';
      current.dataset.vpfCurrent = '';
      current.placeholder = this.t('current_placeholder');
      if (number(this.answer.current)) current.value = String(this.answer.current);
      const currentLabel = node('label', 'vpf__field-label', `${this.t('current_label')} · ${this.t('optional')}`);
      currentLabel.htmlFor = current.id;
      const help = node('p', 'vpf__field-help', this.t('current_help'));
      help.id = `${current.id}-help`;
      current.setAttribute('aria-describedby', help.id);
      currentWrap.append(currentLabel, current, help);
      fields.append(customWrap, currentWrap);
      stage.append(fields);
    }
    renderStep(focus = true) {
      this.isResults = false;
      this.workspace.removeAttribute('aria-busy');
      this.workspace.replaceChildren(this.topBar());
      const key = this.steps()[this.stepIndex];
      const layout = node('div', `vpf__body-layout${key === 'goal' ? ' vpf__body-layout--goal' : ''}`);
      if (this.stepIndex > 0) layout.append(this.contextPanel());
      const stage = node('div', 'vpf__stage');
      const heading = node('h3', 'vpf__question', this.config[`question_${key}`]);
      heading.id = `vpf-${this.dataset.sectionId}-question`;
      heading.tabIndex = -1;
      stage.append(heading);
      if (key === 'features') stage.append(node('span', 'vpf__optional', this.t('optional')));
      const helpKey = { phase: 'phase_help', pump: 'pump_help', motor: 'hp_help', operation: 'operation_help', features: 'features_help' }[key];
      if (helpKey) stage.append(node('p', 'vpf__helper', key === 'features' && this.featureCopy.section.intro ? this.featureCopy.section.intro : this.t(helpKey)));
      const group = node('fieldset', `vpf__options${key === 'motor' ? ' vpf__options--hp' : ''}${key === 'goal' ? ' vpf__options--goals' : ''}${key === 'features' ? ' vpf__options--features' : ''}`);
      const legend = node('legend', 'vpf__sr', this.config[`question_${key}`]);
      group.append(legend);
      this.options(key).forEach((choice) => group.append(this.optionCard(key, choice)));
      stage.append(group);
      if (key === 'goal') stage.append(node('p', 'vpf__photo-note', this.config.media_help));
      if (key === 'motor') this.motorFields(stage);
      this.errorNode = node('p', 'vpf__error');
      this.errorNode.hidden = true;
      this.errorNode.setAttribute('role', 'alert');
      stage.append(this.errorNode);
      const nav = node('div', 'vpf__nav');
      if (this.stepIndex > 0) nav.append(this.button(`← ${this.t('back')}`, 'back', 'vpf__button vpf__button--quiet'));
      const last = this.stepIndex === this.steps().length - 1;
      nav.append(this.button(`${this.t(last ? 'results_button' : 'next')} →`, 'next', 'vpf__button vpf__button--primary'));
      stage.append(nav);
      layout.append(stage);
      this.workspace.append(layout);
      if (focus) heading.focus();
      this.announce(`${this.t('step')} ${this.stepIndex + 1}: ${this.config[`question_${key}`]}`);
    }
    supportLinks() {
      const links = node('div', 'vpf__support-links');
      links.append(this.link(this.t('contact'), '/pages/contact', 'vpf__button vpf__button--primary'), this.link(this.t('whatsapp'), 'https://wa.me/919512172271', 'vpf__button vpf__button--quiet'));
      return links;
    }
    supportPanel(title, body) {
      const panel = node('div', 'vpf__support');
      panel.append(icon('unknown'));
      const heading = node('h3', 'vpf__question', title);
      heading.tabIndex = -1;
      panel.append(heading, node('p', 'vpf__helper', body), this.supportLinks());
      this.workspace.append(panel);
      heading.focus();
      this.announce(title);
      this.resultsNav();
    }
    resultsNav() {
      const nav = node('div', 'vpf__nav vpf__nav--results');
      nav.append(this.button(`← ${this.t('back')}`, 'back', 'vpf__button vpf__button--quiet'), this.button(this.t('restart'), 'restart', 'vpf__text-button'));
      this.workspace.append(nav);
    }
    async showResults(unknown) {
      this.isResults = true;
      this.resultLimit = 3;
      const version = ++this.resultVersion;
      this.workspace.replaceChildren(this.topBar(true), this.summary());
      if (unknown) { this.workspace.removeAttribute('aria-busy'); return this.supportPanel(this.t('unknown_title'), this.t('unknown_body')); }
      const loading = node('p', 'vpf__loading', this.t('loading'));
      this.workspace.append(loading);
      this.workspace.setAttribute('aria-busy', 'true');
      this.announce(this.t('loading'));
      try {
        const rules = await this.loadRules();
        if (!this.isConnected || version !== this.resultVersion) return;
        this.workspace.removeAttribute('aria-busy');
        loading.remove();
        this.matches = VukarProductFinder.selectCandidates(rules, this.catalog, this.answer);
        if (!this.matches.length) return this.supportPanel(this.t('no_fit_title'), this.t('no_fit_body'));
        const header = node('div', 'vpf__results-heading');
        const heading = node('h3', 'vpf__question', this.t(this.answer.goal === 'device' ? 'controls_title' : 'results_title'));
        heading.tabIndex = -1;
        header.append(heading, node('p', 'vpf__helper', this.t(this.answer.goal === 'device' ? 'controls_intro' : 'results_intro')));
        this.workspace.append(header, node('p', 'vpf__compatibility', this.answer.goal === 'device' ? this.config.control_note : this.config.compatibility_note));
        this.resultList = node('div', 'vpf__products');
        this.moreContainer = node('div', 'vpf__more');
        this.workspace.append(this.resultList, this.moreContainer);
        this.renderResultsList();
        const timerOverview = this.timerOverviewProduct();
        if (timerOverview) {
          const overview = node('p', 'vpf__helper');
          overview.append(this.link(timerOverview.title, timerOverview.url, 'vpf__product-compare'));
          this.workspace.append(overview);
        }
        const support = node('div', 'vpf__support-footer');
        const copy = node('div');
        copy.append(node('h4', 'vpf__support-title', this.t('support_heading')), node('p', 'vpf__field-help', this.t('support_body')));
        support.append(copy, this.supportLinks());
        this.workspace.append(support);
        this.resultsNav();
        heading.focus();
        this.announce(`${this.matches.length} ${this.t('results_count')}`);
      } catch (_) {
        if (version !== this.resultVersion) return;
        this.workspace.removeAttribute('aria-busy');
        loading.remove();
        this.supportPanel(this.t('error_title'), this.t('error_body'));
      }
    }
    timerOverviewProduct() {
      if (this.answer.goal !== 'device' || !this.answer.features.includes('clock')) return null;
      if (!this.matches.some((match) => ['DEVK3', 'DEVP2'].includes(cleanModel(match.rule.model)))) return null;
      return this.catalog.find((product) => product.handle === 'digital-clock-timer-device' && product.available === true && product.title && product.url) || null;
    }
    comparisonURL() {
      if (this.answer.goal === 'device' || this.answer.goal === 'meter') return '/pages/digital-meter-comparison';
      if (this.answer.phase === 'three') return '/pages/three-phase-dol-starter-panel-comparison';
      const links = { borewell: '/pages/single-phase-borewell-submersible-pump-starter-panel-comparison', openwell: '/pages/single-phase-openwell-submersible-starter-panel-comparison', monoblock: '/pages/single-phase-monoblock-pump-starter-panel-comparison' };
      return links[this.answer.pump] || '/pages/compare-motor-starter-panel';
    }
    whyMatched() {
      const reasons = [this.t(`choice_${this.answer.phase}`)];
      if (this.answer.goal === 'panel') reasons.push(this.t(`choice_${this.answer.pump}`), `${this.answer.hp} ${this.t('hp_unit')}`);
      return reasons.concat(this.answer.features.map((feature) => this.t(`feature_${feature}`)));
    }
    productCard(match) {
      const { product, rule, variant } = match;
      const card = node('article', 'vpf__product');
      const media = node('div', 'vpf__product-media');
      if (product.image) {
        const image = node('img', 'vpf__product-image');
        image.src = product.image; image.alt = product.title; image.width = 300; image.height = 300; image.loading = 'lazy'; image.decoding = 'async';
        image.addEventListener('error', () => { image.remove(); media.append(icon(this.answer.goal)); }, { once: true });
        media.append(image);
      } else media.append(icon(this.answer.goal));
      const body = node('div', 'vpf__product-body');
      body.append(node('p', 'vpf__model', rule.model), node('h4', 'vpf__product-title', product.title));
      const price = node('p', 'vpf__price');
      if (variant && number(variant.price)) {
        try { price.textContent = new Intl.NumberFormat('en-IN', { style: 'currency', currency: this.dataset.currency || 'INR', maximumFractionDigits: 2 }).format(variant.price / 100); }
        catch (_) { price.textContent = `${this.dataset.currency || 'INR'} ${(variant.price / 100).toFixed(2)}`; }
        body.append(price, node('p', 'vpf__price-help', this.t(this.answer.goal === 'panel' ? 'price_help' : 'control_price_help')));
      } else body.append(node('p', 'vpf__price-help', this.t('unpriced_control')));
      body.append(node('p', 'vpf__why-label', this.t('why')));
      const reasons = node('ul', 'vpf__reasons');
      this.whyMatched().forEach((reason) => reasons.append(node('li', '', reason)));
      body.append(reasons);
      const actions = node('div', 'vpf__product-actions');
      const url = new URL(product.url, window.location.origin);
      if (variant) url.searchParams.set('variant', String(variant.id));
      actions.append(this.link(this.t('view'), `${url.pathname}${url.search}`, 'vpf__button vpf__button--primary'), this.link(this.t('compare'), this.comparisonURL(), 'vpf__product-compare'));
      body.append(actions);
      card.append(media, body);
      return card;
    }
    renderResultsList() {
      this.resultList.replaceChildren(...this.matches.slice(0, this.resultLimit).map((match) => this.productCard(match)));
      this.moreContainer.replaceChildren();
      if (this.matches.length > this.resultLimit) this.moreContainer.append(this.button(this.t('more'), 'more', 'vpf__button vpf__button--quiet'));
      else this.moreContainer.append(node('p', 'vpf__field-help', this.t('no_more')));
    }
  }
  customElements.define('vukar-product-finder', VukarProductFinder);
})();
